import React, { useEffect, useState } from 'react';
import { formatDate, timeConvert } from './../common';

const Agenda = ({isEventLive, agendaDetails, timeZone}) => {
  // Sample data; this would normally come from an API or state
  
  const [agendaList, setAgendaList] = useState([]);

  useEffect(()=>{
    //setAgendaList(agendaDetails || []);
    groupAgendasByDate(agendaDetails);
  }, [agendaDetails]);

  const groupAgendasByDate = (_agendaList) => {
    const grouped = _agendaList.reduce((acc, item) => {
      const date = item.eventDate.split("T")[0];
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(item);
      return acc;
    }, {});
  
    const sortedDates = Object.keys(grouped).sort();    
    const sortedList = sortedDates.map((date) => ({
      eventDate: date,
      agendas: grouped[date].sort((a, b) => new Date(a.startTime) - new Date(b.startTime)),
    }));

    setAgendaList(sortedList || []);
  };

  return (
    <div id="Agenda" className="Agenda w3-card-4 w3-margin-bottom-2em w3-round w3-white p-0 p-md-3">
      <div className='w3-container w3-white w3-round'>
        <h4 className='roboto-bold mt-3 mb-3'>AGENDA</h4>

        {/* <p className='roboto-medium color-black '>
          <span className="w3-margin-right">Date: {agendaItems[0].date} - {agendaItems[agendaItems.length - 1].date}</span>
          {isEventLive && <><span>&nbsp; | &nbsp;</span><span className="w3-margin-left"> Location: The Ritz-Carlton, Half Moon Bay</span></>}
        </p> */}

        {/* agendaItems.map((dayData) => (
          <div key={dayData.date} className='w3-card-4 w3-margin-bottom-2em w3-round-large'>
            <header className='w3-container w3-theme w3-round-large w3-padding'>
              <div className='agenda-header d-sm-flex align-items-sm-center'>
                <div className='text-white fs-1'>
                  <span className='mb-2 mb-sm-0'>{formatDate(dayData.date)}</span> 
                  <span>&nbsp; | &nbsp;</span> 
                  <span className='mb-2 mb-sm-0 me-3'>{dayData.events[0].timeStart} - {dayData.events[dayData.events.length - 1].timeEnd} </span>
                </div>
                <div>
                  <button type='button' className='btn btn-meeting-link btn color-purple d-flex justify-content-center align-items-center'>
                  <span className="me-1 d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 48 48">
                        <path fill="#5059c9" d="M44,22v8c0,3.314-2.686,6-6,6s-6-2.686-6-6V20h10C43.105,20,44,20.895,44,22z M38,16	c2.209,0,4-1.791,4-4c0-2.209-1.791-4-4-4s-4,1.791-4,4C34,14.209,35.791,16,38,16z"></path><path fill="#7b83eb" d="M35,22v11c0,5.743-4.841,10.356-10.666,9.978C19.019,42.634,15,37.983,15,32.657V20h18	C34.105,20,35,20.895,35,22z M25,17c3.314,0,6-2.686,6-6s-2.686-6-6-6s-6,2.686-6,6S21.686,17,25,17z"></path><circle cx="25" cy="11" r="6" fill="#7b83eb"></circle><path d="M26,33.319V20H15v12.657c0,1.534,0.343,3.008,0.944,4.343h6.374C24.352,37,26,35.352,26,33.319z" opacity=".05"></path><path d="M15,20v12.657c0,1.16,0.201,2.284,0.554,3.343h6.658c1.724,0,3.121-1.397,3.121-3.121V20H15z" opacity=".07"></path><path d="M24.667,20H15v12.657c0,0.802,0.101,1.584,0.274,2.343h6.832c1.414,0,2.56-1.146,2.56-2.56V20z" opacity=".09"></path><linearGradient id="DqqEodsTc8fO7iIkpib~Na_zQ92KI7XjZgR_gr1" x1="4.648" x2="23.403" y1="14.648" y2="33.403" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#5961c3"></stop><stop offset="1" stopColor="#3a41ac"></stop></linearGradient><path fill="url(#DqqEodsTc8fO7iIkpib~Na_zQ92KI7XjZgR_gr1)" d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"></path><path fill="#fff" d="M18.068,18.999H9.932v1.72h3.047v8.28h2.042v-8.28h3.047V18.999z"></path>
                    </svg>
                  </span>
                  <span>Join Meeting</span>
                  </button>
                </div>
              </div>
            </header>

            <div className='w3-container w3-padding-large roboto-bold'>
              <table>
                <tbody>
                  {dayData.events.map((event) => (
                    <tr key={event.timeStart} className={event.type === eventTypes.break ? 'color-blue' : ''}>
                      <td>{event.timeStart} &mdash; {event.timeEnd}</td>
                      <td>{event.title}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )) */}

        {
          agendaList.map((agenda, index) => (
            <div key={agenda.eventDate+'_'+index} className='w3-card-4 w3-margin-bottom-2em w3-round-large'>
              { agenda.agendas[0].teamsMeetingLink && 
                <>
                  <header className='w3-container w3-theme w3-round-large w3-padding'>
                    <div className='agenda-header d-sm-flex align-items-sm-center'>
                      <div className='text-white fs-1'>
                        <span className='mb-2 mb-sm-0'>{formatDate(agenda.eventDate)}</span> 
                        <span>&nbsp; | &nbsp;</span> 
                        <span className='mb-2 mb-sm-0 me-2'>
                          <div className='d-inline me-2'>{timeConvert(agenda.agendas[0].startTime)} - {timeConvert(agenda.agendas[agenda.agendas.length-1].endTime)}</div>
                          <div className='d-inline me-3'>{timeZone}</div>
                        </span>
                      </div>
                      <div>
                        <a target='_blank' href={agenda.agendas[0].teamsMeetingLink} type='button' className='btn btn-meeting-link btn color-purple d-flex justify-content-center align-items-center'>
                        <span className="me-1 d-flex align-items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 48 48">
                              <path fill="#5059c9" d="M44,22v8c0,3.314-2.686,6-6,6s-6-2.686-6-6V20h10C43.105,20,44,20.895,44,22z M38,16	c2.209,0,4-1.791,4-4c0-2.209-1.791-4-4-4s-4,1.791-4,4C34,14.209,35.791,16,38,16z"></path><path fill="#7b83eb" d="M35,22v11c0,5.743-4.841,10.356-10.666,9.978C19.019,42.634,15,37.983,15,32.657V20h18	C34.105,20,35,20.895,35,22z M25,17c3.314,0,6-2.686,6-6s-2.686-6-6-6s-6,2.686-6,6S21.686,17,25,17z"></path><circle cx="25" cy="11" r="6" fill="#7b83eb"></circle><path d="M26,33.319V20H15v12.657c0,1.534,0.343,3.008,0.944,4.343h6.374C24.352,37,26,35.352,26,33.319z" opacity=".05"></path><path d="M15,20v12.657c0,1.16,0.201,2.284,0.554,3.343h6.658c1.724,0,3.121-1.397,3.121-3.121V20H15z" opacity=".07"></path><path d="M24.667,20H15v12.657c0,0.802,0.101,1.584,0.274,2.343h6.832c1.414,0,2.56-1.146,2.56-2.56V20z" opacity=".09"></path><linearGradient id="DqqEodsTc8fO7iIkpib~Na_zQ92KI7XjZgR_gr1" x1="4.648" x2="23.403" y1="14.648" y2="33.403" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#5961c3"></stop><stop offset="1" stopColor="#3a41ac"></stop></linearGradient><path fill="url(#DqqEodsTc8fO7iIkpib~Na_zQ92KI7XjZgR_gr1)" d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"></path><path fill="#fff" d="M18.068,18.999H9.932v1.72h3.047v8.28h2.042v-8.28h3.047V18.999z"></path>
                          </svg>
                        </span>
                        <span>Join Meeting</span>
                        </a>
                      </div>
                    </div>
                  </header>
      
                  <div className='w3-container w3-padding-large roboto-bold'>
                    <table>
                      <tbody>
                        
                        {agenda.agendas.map((event, index) => (
                          <tr key={'index_'+index} className={event.isHighlighted ? 'color-blue' : ''}>
                            <td>{timeConvert(event.startTime)} &mdash; {timeConvert(event.endTime)}</td>
                            <td>{event.agendaDetails}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              }
            </div>
          ))
        }
      </div>
    </div>
  );
}

export default Agenda;
